/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import { TImage } from 'types/portfolio';

import s from '../ClassicPortfolio.module.css';

type TClassicPortfolioImageProps = {
  caption: string;
  image: TImage;
};

const ClassicPortfolioImage: React.FC<TClassicPortfolioImageProps> = ({
  image: { medium },
  caption,
}) => (
  <figure className={s.item}>
    <div className={s.imageWrapper}>
      <img alt={caption} className={s.image} src={medium} />
      <figcaption className={s.fullDescription}>{caption}</figcaption>
    </div>
    <span aria-hidden="true" className={s.description}>
      {caption}
    </span>
  </figure>
);

export { ClassicPortfolioImage };
